import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 类型
 */
class Type extends UltMeta {
    PORT = new Meta(1, "码头");
    HARBOR = new Meta(2, "港口");
    BERTH = new Meta(3, "泊位");
}

export const TYPE = new Type();

/**
 * 码头/泊位类型
 */
class PortBerthType extends UltMeta {
    CONTAINERS = new Meta(1, "集装箱");
    DRY_POWDER = new Meta(2, "干散");
    LIQUID_DISPERSION = new Meta(3, "液散");
    PASSENGER_SHIP = new Meta(4, "客船");
    REPAIR = new Meta(5, "修理");
    UNIVERSAL = new Meta(6, "通用");
    OTHER = new Meta(7, "其他");
}

export const PORT_BERTH_TYPE = new PortBerthType();

/**
 * 装饰属性
 */
class HandlingAttribute extends UltMeta {
    LOAD = new Meta(1, "装");
    UNLOAD = new Meta(2, "卸");
    HANDLING = new Meta(3, "装卸");
}

export const HANDLING_ATTRIBUTE = new HandlingAttribute();

/**
 * 货物类型
 */
class GoodsType extends UltMeta {
    COAL = new Meta(1, "煤炭");
    IRON_ORE = new Meta(2, "铁矿石");
    STEEL = new Meta(3, "钢材");
    CEMENT = new Meta(4, "水泥");
    SAND = new Meta(5, "砂石料");
    CRUDE_OIL = new Meta(6, "原油");
    LNG = new Meta(7, "LNG");
    LPG = new Meta(8, "LPG");
    GRAIN = new Meta(9, "粮食");
    RAW_SUGAR = new Meta(10, "原糖");
    SOYBEANS = new Meta(11, "大豆");
    BAUXITE = new Meta(12, "铝土矿");
    CAR = new Meta(13, "汽车");
    WOOD = new Meta(14, "木材");
}

export const GOODS_TYPE = new GoodsType();

/**
 * 关联企业
 */
class Enterprise extends UltMeta {
    CLP_CJ = new Meta(1, "中电建长九");
    CLP_CL = new Meta(2, "中电建长崃（浠水）");
    HX_GL = new Meta(3, "华新骨料（阳新）");
    HX_GREEN = new Meta(4, "华新绿色建材（武穴）");
    HS_HX_GREEN = new Meta(5, "黄石华新绿色建材");
    WX_MB = new Meta(6, "武穴民本");
    YX_WS_KT = new Meta(7, "阳新娲石矿投");
    CLP_QC = new Meta(8, "中电建蕲春");
}

export const ENTERPRISE = new Enterprise();

/**
 * 所属航道
 */
class Waterway extends UltMeta {
    YB_LZ = new Meta(1, "宜宾合江门～泸州王爷庙");
    LZ_JJ = new Meta(2, "泸州王爷庙～江津通泰门");
    JJ_CQ = new Meta(3, "江津通泰门～重庆胡家滩");
    CQ_CQ = new Meta(4, "重庆胡家滩～重庆羊角滩");
    CQ_PL = new Meta(5, "重庆羊角滩～涪陵李渡大桥");
    PL_ZG = new Meta(6, "涪陵李渡大桥～秭归庙河");
    ZG_YC = new Meta(7, "秭归庙河～宜昌中水门");
    YC_SZ = new Meta(8, "宜昌中水门～松滋跨宝山");
    SZ_JZ = new Meta(9, "松滋跨宝山～荆州四码头");
    JZ_YY = new Meta(10, "荆州四码头～岳阳城陵矶");
    YY_WH = new Meta(11, "岳阳城陵矶～武汉长江大桥");
    WH_AQ = new Meta(12, "武汉长江大桥～安庆吉阳矶");
    AQ_WF = new Meta(13, "安庆吉阳矶～芜湖高安圩");
    WF_WF = new Meta(14, "芜湖高安圩～芜湖长江大桥");
    WF_NJ = new Meta(15, "芜湖长江大桥～南京燕子矶");
    NJ_NJ = new Meta(16, "南京燕子矶～南京新生圩");
    NJ_JY = new Meta(17, "南京新生圩～江阴长江大桥");
    JY_TC = new Meta(18, "江阴长江大桥～太仓浏河口");
}

export const WATERWAY = new Waterway();
